'use client'

import ImageWithFallback from 'src/components/ImageWithFallBack'

interface TestimonialCardProps {
  testimonial: any
  idx: number
  activeIndex: number
}

const TestimonialCard = ({
  testimonial,
  idx,
  activeIndex
}: {
  testimonial: any
  idx: number
  activeIndex: number
}) => {
  return (
    <>
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        .custom-scrollbar::-webkit-scrollbar-button {
          display: none;
        }
      `}</style>
      <div
        className={` w-full h-full  bg-white rounded-xl p-8 shadow-lg transition-all duration-300 outline outline-1 outline-gray-200  ${
          idx === activeIndex ? 'scale-105' : 'scale-95 opacity-50'
        }`}>
        <div className="flex items-center gap-6 mb-6 w-full">
          <div className="flex-shrink-0 w-[276px] h-[200px] overflow-hidden relative">
            <ImageWithFallback
              key={`brand-logo-${testimonial.storeName}}`}
              src={testimonial.img}
              alt={`${testimonial.name}'s company`}
              fill
              sizes="200px"
              style={{
                objectFit: 'cover'
              }}
              className="rounded-lg"
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 mb-4 text-[#67848B]">
          <h4 className="font-semibold text-2xl leading-4">
            {testimonial.name}
          </h4>
          <p className="">{testimonial.designation}</p>
        </div>
        <div className="text-[#636363] text-sm leading-relaxed h-[160px] overflow-y-auto rounded-lg line-clamp-[8] custom-scrollbar pr-1">
          {testimonial.words}
        </div>
        <div
          className="flex items-center gap-2 justify-start h-20 mt-6 relative"
          data-item="brand-logo">
          <div className="relative h-16 w-32">
            <ImageWithFallback
              src={testimonial.orgLogo}
              alt={`${testimonial.orgName} logo`}
              fill
              sizes="128px"
              style={{
                objectFit: 'contain'
              }}
              className="rounded-sm"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default TestimonialCard
